import { reactive } from "vue";

export type ToastKind = "success" | "error" | "info";

export type ToastItem = {
  id: number;
  kind: ToastKind;
  message: string;
};

const toasts = reactive<ToastItem[]>([]);
let nextId = 1;

function push(kind: ToastKind, message: string) {
  const id = nextId++;
  toasts.push({ id, kind, message });
  window.setTimeout(() => remove(id), 3000);
}

function remove(id: number) {
  const index = toasts.findIndex((toast) => toast.id === id);
  if (index >= 0) toasts.splice(index, 1);
}

export function useToast() {
  return {
    toasts,
    remove,
    success: (message: string) => push("success", message),
    error: (message: string) => push("error", message),
    info: (message: string) => push("info", message)
  };
}
